<template>

        <div class="printShop">

            <h2>Printshop</h2>

            <div class="columns is-12">
                <div class="column is-6">
                    <p>
                        Ein Plakat für eine Aktion in Ihrer Apotheke... ein Flyer für eine Veranstaltung... Mit dem HERBA-Printshop können Sie mit nur wenigen Schritten Ihre eigenen Marketingmaterialien gestalten und diese gleich online bestellen und produzieren lassen. Einfach, schnell und individuell.
                    </p>
                    <p>
                        Sie finden im Printshop unterschiedliche Vorlagen und können auf Basis des von uns bereitgestellten Bilderpools und natürlich auch mit eigenen Bildern, die Sie hochladen, nach Belieben gestalten. Das fertige Druckwerk wird direkt zu Ihnen in die Apotheke geliefert</p>
                    </p>

                    <h3>Die ideale One-Stop-Shop Lösung für Ihre individuelle Marketingplanung.</h3>

                    <custom-button type="blue" size="small" icon="icon-ak-vor" @click.native="openLink('http://webprint.haltmeyer.at/chemosan')">
                        <div class="buttonText" slot="button-text">zum HERBA-Printshop</div>
                    </custom-button>
                </div>

                <div class="column is-6">

                    <img src="/static/img/printshop.png" />

                </div>
            </div>

        </div>

</template>


<script>
export default {

    name: 'calendarTabPrintshop',

    props: {
        apoId: {
            type: Number,
            default: null
        },
    },


    computed: {


    },

    data() {

        return {
            isLoading: false,
        }

    },

    created() {

    },

    mounted() {


    },

    methods: {

        openLink(url) {
            window.open(url, '_blank');
        }

    }

}
</script>


<style scoped>

    .printShop p {
        margin-bottom: 1em;
        white-space: normal;
    }
    .printShop img {
        max-width: 400px;
        width: 100%;
    }

    .printShop h2, .printShop h3 {
        white-space: normal;
    }
    .printShop h2 {
        font-weight: 400;
        font-size: 20px;
        margin-bottom: 15px;
    }
    .printShop h3 {
        font-size: 16px;
        font-weight: 400;
        margin: 25px 0;
    }

    .printShop >>> .buttonText {
        text-transform: none !important;
        font-size: 14px;
    }

    .printShop >>> .button.small .icon {
        font-size: 18px;
        height: 18px;
        width: 16px;
        line-height: 18px;
    }

</style>
